module.exports = __webpack_public_path__ + "static/media/pic3.554ad1fc.jpg";